import { useTranslation } from "react-i18next"
import { ColumnItem } from "../../../../../../utils/types/generals"
import { Settings } from "../../../../../../components/settings"
import { BaseMenuClick } from "../../../../../../components/baseMenu"
import { useMenu } from "./menu"

export const useColumn = ({ click }: { click?: BaseMenuClick }): ColumnItem[] => {
    const { t } = useTranslation()
    const menu = useMenu()

    return [
        {
            id: 'register',
            label: t('general.serviceTime.time.main.table.register'),
            sortable: true
        },
        {
            id: 'description',
            label: t('general.serviceTime.time.main.table.description'),
            sortable: true
        },
        {
            id: 'area',
            label: t('general.serviceTime.time.main.table.area'),
            sortable: true
        },
        {
            id: 'department',
            label: t('general.serviceTime.time.main.table.department'),
            sortable: true
        },
        {
            id: 'action',
            label: t('general.tags.action'),
            renderCell: (params) => {
                return (
                    <Settings
                        row={params?.row}
                        rowLength={1}
                        menu={{
                            click: (item) => { if (click) { click(item, params?.row) } },
                            menuItems: menu
                        }
                        }
                    />
                )
            }
        },
    ]
}